"use client";

import Fuse from "fuse.js";
import Link from "next/link";
import { useMemo, useState } from "react";

import { BLOG_POSTS } from "@/lib/blog/registry";

const POPULAR = [
  "inventory-and-working-capital",
  "top-5-inventory-loss-fmcg",
  "fefo-vs-fifo-practical-guide",
  "audit-ready-stock-records",
  "simplify-stocktaking-smb",
] as const;

export function NotFoundSearch() {
  const [q, setQ] = useState("");
  const fuse = useMemo(
    () =>
      new Fuse(
        BLOG_POSTS.map((p) => ({
          slug: p.slug,
          title: p.title,
          description: p.description,
          keywords: p.keywords.join(" "),
        })),
        { keys: ["title", "description", "keywords"], threshold: 0.35 },
      ),
    [],
  );
  const results = useMemo(() => {
    const t = q.trim();
    if (t.length < 2) return [];
    return fuse.search(t, { limit: 6 }).map((r) => r.item);
  }, [fuse, q]);

  return (
    <div className="ed-not-found-search">
      <p className="ed-not-found-search__label">Search {BLOG_POSTS.length} guides</p>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search titles…"
        className="ed-not-found-search__input"
        aria-label="Search blog"
      />
      {results.length > 0 ? (
        <ul className="ed-not-found-search__ul">
          {results.map((r) => (
            <li key={r.slug}>
              <Link href={`/blog/${r.slug}`}>{r.title}</Link>
            </li>
          ))}
        </ul>
      ) : null}
      <div className="ed-not-found-popular">
        <p className="ed-not-found-popular__label">Popular right now</p>
        <ul>
          {POPULAR.map((slug) => {
            const p = BLOG_POSTS.find((x) => x.slug === slug);
            if (!p) return null;
            return (
              <li key={slug}>
                <Link href={`/blog/${slug}`}>{p.title}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
